import React, { createContext, useContext, useState, useEffect, useMemo } from 'react'
import useFetchPost from '../../../hooks/useFetchPost'
import useFetchGet from '../../../hooks/useFetchGet'
import { downloadFile } from '../../../utils/tools'
import axios from 'axios'

const ReportPanel = createContext()

export const ReportPanelProvider = ({ticker, template, uuid, peerAnalysisTemplate, children }) => {
    const [ graphParams, setGraphParams ] = useState({})
    const [ peerAnalysis, setPeerAnalysis ] = useState({isLoading: false, data: null})
    const [ peerAnalysisCompetitors, setPeerAnalysisCompetitors ] = useState(null)
    const [ issues, setIssues ] = useState(null)

    const tickerValue = useMemo(() => ticker?.value ,[ticker])

    useEffect(() => {
        uuid && tickerValue && axios.get(`/reports/getPanelParams?uuid=${uuid}&ticker=${tickerValue}`)
            .then(res => res.data)
            .then(res => {
                setPeerAnalysisCompetitors(res.params?.peer_analysis || [])
                setGraphParams(res.params)
                setIssues(res.issues)
            })
        return () => {}            
    },[uuid, tickerValue])

    useEffect(() => {
        if(!peerAnalysisTemplate || !Array.isArray(peerAnalysisCompetitors)) return 
        setPeerAnalysis({isLoading: true, data: null})
        axios.get(`/reports/peerAnalysis?peerAnalysis=${JSON.stringify(peerAnalysisTemplate)}&ticker=${ticker}&competitors=${peerAnalysisCompetitors}`)
        .then(res => res.data)
        .then(res => setPeerAnalysis({isLoading: false, data: res}))
        return () => {}
    },[peerAnalysisTemplate, ticker, peerAnalysisCompetitors])

    const exportToCSV = async () => {
        const res = await axios.get(`/reports/downloadCSV?uuid=${uuid}&ticker=${tickerValue}`)
        if(res.status===200){
            const blob = await res.blob()
            const file = window.URL.createObjectURL(blob)
            downloadFile(file, `FE-export-${ticker.name}.csv`)
        }
    }

    const updatePeerAnalysisCompetitors = (competitors) => {
        // fetch('/reports/updatePeerAnalysisCompetitors', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({
        //         ticker: tickerValue, competitors, uuid
        //     })
        // })
        axios({
            method: 'POST',
            url: `/reports/updatePeerAnalysisCompetitors`,
            data:{ticker: tickerValue, competitors, uuid}
        })
        .then(res => res.status === 200 && setPeerAnalysisCompetitors(competitors))
    }

    const reportsGraphBody = useMemo(() => ({
        ticker: tickerValue, 
        template,
    }) ,[tickerValue, template])

    const { data, isLoading } = useFetchPost(tickerValue && template && '/reports/getGraphs', reportsGraphBody)
    const { data: avg } = useFetchPost(tickerValue && template && '/reports/getIndustryAvg', reportsGraphBody)
    const { data: companyInfo } = useFetchGet(tickerValue && `/reports/companyInfo?ticker=${tickerValue}`)

    return (
        <ReportPanel.Provider value={{
            ticker,
            data, 
            isLoading,
            graphParams,
            avg,
            exportToCSV,
            peerAnalysis,
            peerAnalysisCompetitors,
            updatePeerAnalysisCompetitors,
            companyInfo,
            issues
        }}>
            { children}
        </ReportPanel.Provider>
    )
}

export function useReportPanelContext() {
    return useContext(ReportPanel)
}